import './DashbordClient.scss';
import 'chart.piecelabel.js';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import { API_URI_CVTheque, getCVThequeENV } from '../../config';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useGetRequest from '../../hooks/useGetRequest';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { adapter4BackendProxy } from '../../Utils/utilsDashboards';
import BoxesCountExpert from '../Admin/Dashbords/BoxesCountExpert';
import ChiffreAffaireExpert from '../Admin/Dashbords/ChiffreAffaireExpert';
import EchancierExpert from '../Admin/Dashbords/EchancierExpert';
import StatutCras from '../Admin/Dashbords/StatutCras';
import StatutFactures from '../Admin/Dashbords/StatutFactures';
import StatutMissionExpert from '../Admin/Dashbords/StatutMissionExpert';
import TotalAoExpert from '../Admin/Dashbords/TotalAoExpert';

//  npm install chart.piecelabel.js
//  npm install --save react-apexcharts & also Apexcharts
//  npm install --save react-icons

function DashbordExpert() {

    const axiosPrivate = useAxiosPrivate();
    const { setBackdropOpen} = useUtilities();
    const { i18n } = useTranslation();
    //const role=useRole();
    const [DataForCandidatureRecuParAO, SetDataForCandidatureRecuParAO] = useState();
    //const [statusCandidatueByAO, SetStatusCandidatueByAO] = useState();
    const { data: expertInfos } = useGetRequest({ url: 'expert/getMyInfos' });
    const [expertId, setExpertId]=useState();
    const [missionsCount,setMissionsCount]=useState();
    const [crasCount,setCrasCount]=useState();
    const {device}=useWindowSize();
    //const [facturesCount,setFacturesCount]=useState();
    const [chiffreAffaire,setChiffreAffaire]=useState();
    const [lengthDemandeRdv,setLengthDemandeRdv]=useState();
    useEffect(() =>{
        if(expertInfos){
            console.log('expertInfos',expertInfos);
            setExpertId(expertInfos?.user?.expertId);
            //setCompanyName(clientInfos?.collaborator?.companyDataId?.profileEntreprise?.nom);
        }
    }, [expertInfos]);

    useEffect(() =>{
        if(expertId){
            console.log('expertId',expertId);
            getDataForCandidatureRecuParAO();
            //setCompanyName(clientInfos?.collaborator?.companyDataId?.profileEntreprise?.nom);
        }
    }, [expertId]);

    //useEffect(() =>{
    //    getStatusCandidatueByAO();
    //    console.log(statusCandidatueByAO);
    //}, [statusCandidatueByAO]);

    useEffect(() =>{
        if(DataForCandidatureRecuParAO){
            console.log('DataForCandidatureRecuParAO',DataForCandidatureRecuParAO);
            SetDataForCandidatureRecuParAO(DataForCandidatureRecuParAO);
        }
    }, [DataForCandidatureRecuParAO]);

    //const [result, setResult] = useState();
    //const curUrl = url.split('/').pop();

    const getDataForCandidatureRecuParAO = async () => {
        try {
            setBackdropOpen(true);
            // let response1, responseData1;
            // if(getCVThequeENV() == 'remote'){
            //     response1 = await axiosPrivate.get(
            //         '/proxy/getDataForCandidatureRecuParAO/'+ encodeURIComponent(role),
            //     );
            //     responseData1 = response1.data;
            // }
            // else {
            //     console.log('rooooooooooooooolle',role);
            //     response1 = await fetch(API_URI_CVTheque + 'getDataForCandidatureRecuParAO/'+ encodeURIComponent(role), {
            //         method: 'Get',
            //         // headers: {
            //         //     'Content-Type': 'multipart/form-data',
            //         //     'accept': 'application/json'
            //         // },
            //     });
            //     responseData1 = await response1.json();
            // }

            // console.log('lahsen will punish reda', responseData1);
            //const [candidaturesCount,missions,cras,factures,chiffreAffaire,rdvs]=

            //const candidaturesCount=await adapter4BackendProxy(axiosPrivate,  'expert/getStatusCandidatures/'+ encodeURIComponent(expertId));
            //const missions=await adapter4BackendProxy(axiosPrivate,  'expert/getMissions/'+ encodeURIComponent(expertId));
            //const cras=await adapter4BackendProxy(axiosPrivate,  'expert/getCrasX/'+ encodeURIComponent(expertId));
            //const chiffreAffaire=await adapter4BackendProxy(axiosPrivate,  'expert/getCA/'+ encodeURIComponent(expertId));
            //const rdvs=await adapter4BackendProxy(axiosPrivate,  'expert/getRdv/'+ encodeURIComponent(expertId));

            const [
                candidaturesCount,
                missions,
                cras,
                chiffreAffaire,
                rdvs
            ] = await Promise.all([
                adapter4BackendProxy(axiosPrivate, `expert/getStatusCandidatures/${encodeURIComponent(expertId)}`).catch(error => {
                    console.error('Error fetching status candidatures for expert:', error);
                    return null;
                }),
                adapter4BackendProxy(axiosPrivate, `expert/getMissions/${encodeURIComponent(expertId)}`).catch(error => {
                    console.error('Error fetching missions for expert:', error);
                    return null;
                }),
                adapter4BackendProxy(axiosPrivate, `expert/getCrasX/${encodeURIComponent(expertId)}`).catch(error => {
                    console.error('Error fetching CrasX for expert:', error);
                    return null;
                }),
                adapter4BackendProxy(axiosPrivate, `expert/getCA/${encodeURIComponent(expertId)}`).catch(error => {
                    console.error('Error fetching CA for expert:', error);
                    return null;
                }),
                adapter4BackendProxy(axiosPrivate, `expert/getRdv/${encodeURIComponent(expertId)}`).catch(error => {
                    console.error('Error fetching Rdv for expert:', error);
                    return null;
                })
            ]);
            SetDataForCandidatureRecuParAO(candidaturesCount);
            setMissionsCount(missions);
            setCrasCount(cras);
            setChiffreAffaire(chiffreAffaire);
            setLengthDemandeRdv(rdvs.length);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error);
        }
    };

    //const getStatusCandidatueByAO = async () => {
    //    try {
    //        // let response1, PerStatusCandidatueByAO;
    //        // if(getCVThequeENV() == 'remote'){
    //        //     response1 = await axiosPrivate.get(
    //        //         '/proxy/getStatusCandidatueByAO',
    //        //     );
    //        //     PerStatusCandidatueByAO = response1.data;
    //        // }
    //        // else {
    //        //     response1 = await fetch(API_URI_CVTheque + 'getStatusCandidatueByAO', {
    //        //         method: 'Get',
    //        //         // headers: {
    //        //         //     'Content-Type': 'multipart/form-data',
    //        //         //     'accept': 'application/json'
    //        //         // },
    //        //     });
    //        //     PerStatusCandidatueByAO = await response1.json();
    //        // }
    //        // console.log('lahsen will punish reda', PerStatusCandidatueByAO);
    //        SetStatusCandidatueByAO(await adapter4BackendProxy(axiosPrivate,  'getStatusCandidatueByAO'));
    //    } catch (error) {
    //        console.log(error.response?.status);
    //    }
    //};

    return (
        <div style={{width:'100%',display:'flex',flexDirection:'column',gap:'24px'}}>
            <h4 className='dashFrame13'>{i18n.t('Tableau de bord')}</h4>
            <BoxesCountExpert
                DataForCandidatureRecuParAO={DataForCandidatureRecuParAO}
                chiffreAffaire={chiffreAffaire}
                allCras={crasCount}
                allStatusMissions={missionsCount}
                lengthDemandeRdv={lengthDemandeRdv}
            />
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'24px',width:'100%',height:device=='desktop'?'425px':'auto'}}>
                <TotalAoExpert
                    dataAllAos={DataForCandidatureRecuParAO}
                    width={'100%'}
                    height={device=='desktop'?'400px':'auto'}
                />

            </div>
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'24px',width:'100%',height:device=='desktop'?'425px':'auto'}}>
                <StatutMissionExpert
                    allStatusMissions={missionsCount}
                    width={'100%'}
                    height={device=='desktop'?'400px':'auto'}
                />
            </div>
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'24px',width:'100%',height:device=='desktop'?'425px':'auto'}}>
                <StatutCras
                    allCras={crasCount}
                    filtreClient={false}
                    role={'expert'}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'425px':'auto'}
                />

                <StatutFactures
                    allFactures={chiffreAffaire}
                    filtreClient={false}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'425px':'auto'}
                    role={'expert'}
                />
            </div>
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'24px',width:'100%',height:device=='desktop'?'425px':'auto'}}>
                <ChiffreAffaireExpert
                    chiffreAffaire={chiffreAffaire}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'425px':'auto'}
                />
                <EchancierExpert
                    chiffreAffaire={chiffreAffaire}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'425px':'auto'}
                />
            </div>
        </div>
    );
}

export default DashbordExpert;